import { useEffect, useState } from 'react';
import { initialViewportFlag } from './viewportSsr';

export const useIsDesktop = (breakpoint?: number) => {
    const desktopBreakpoint = breakpoint ?? 1024;
    const [isDesktop, setIsDesktop] = useState(
        () => initialViewportFlag(() => window.innerWidth >= desktopBreakpoint),
    );

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= desktopBreakpoint);
        // Corrects the server's assumed viewport as soon as there is a real one to measure.
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [desktopBreakpoint]);

    return isDesktop;
};
